/**
 * HUD-POPOVER-CLIP-390-1: an info popover is anchored to its button's right edge, so on a narrow viewport it can
 * open past the left edge (GK-ev measured x -83 at 390). The shift slides it back inside a 16px gutter; the left
 * edge wins when the popover is wider than the viewport, so its first words always read.
 */
export const POPOVER_GUTTER_PX = 16;

export function popoverShiftPx(left: number, right: number, viewportWidth: number, gutter = POPOVER_GUTTER_PX): number {
  if (left < gutter) return gutter - left;
  if (right > viewportWidth - gutter) return Math.max(gutter - left, viewportWidth - gutter - right);
  return 0;
}
